/* This file is autogenerated, see readme.md for instructions */
import RibbonSvgIcon from '@bloomreach/banana-theme/icons/ribbon.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RibbonIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RibbonSvgIcon />
    </Icon>
  );
});

RibbonIcon.displayName = 'RibbonIcon';

export default RibbonIcon;
